export const APPLY_MEMBERSHIP = "APPLY_MEMBERSHIP";